import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { CIRCOLARI_IN_ARRIVO } from '../utils/circolariInArrivo';
import DettaglioCircolare from '../components/circolari/DettaglioCircolare';
import { isCircolariDisattivate, isNonInRegola } from '../services/circolariService';
import { API_CIRCOLARI_ASSOCIATO, AvvisoCircolariDisattivate, AvvisoNonInRegola, BackToAreaRiservata } from './CircolariPage';

const CircolareDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [nonInRegola, setNonInRegola] = useState(false);
  const [disattivate, setDisattivate] = useState(false);

  const onErroreAccesso = (error: any): boolean => {
    if (isNonInRegola(error)) { setNonInRegola(true); return true; }
    if (isCircolariDisattivate(error)) { setDisattivate(true); return true; }
    return false;
  };

  if (nonInRegola) return <AvvisoNonInRegola />;
  if (disattivate) return <AvvisoCircolariDisattivate />;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
        <BackToAreaRiservata label="Comunicati e norme" to="/area-riservata/circolari" />
        <DettaglioCircolare
          api={API_CIRCOLARI_ASSOCIATO}
          id={id}
          linkElenco="/area-riservata/circolari"
          etichettaRitorno="Torna a Comunicati e norme"
          testoNonTrovata="La circolare non esiste più oppure non è disponibile per la tua categoria."
          onErroreAccesso={onErroreAccesso}
        />
      </div>
    </div>
  );
};

// Finché l'archivio è «in arrivo» la pagina rimanda alla dashboard (vedi utils/circolariInArrivo.ts)
const CircolareDetailPageGuard: React.FC = () =>
  CIRCOLARI_IN_ARRIVO ? <Navigate to="/area-riservata" replace /> : <CircolareDetailPage />;

export default CircolareDetailPageGuard;
